export default function validate(fields) {
    const errors = {}
    const { displayName, logo } = fields
    if (typeof displayName === 'undefined' || displayName === '') {
        errors.displayName = 'displayName must not be empty'
    }

    if (typeof logo === 'undefined' || logo === '') {
        errors.logo = 'logo must not be empty'
    }
    return errors
}

// export default function validate(values) {
//     const errors = {}
//     console.log("🚀 ~ file: validate.js ~ line 2 ~ validate ~ fields", values)
//     var endpointPatt = /^((25[0-5]|(2[0-4]|1[0-9]|[1-9]|)[0-9])(\.(?!$)|$)){4}$/;
//     const readerArrayErrors = []
//     if (values.readers){
//         values.readers.forEach((reader, readerIndex) => {
//             if (typeof reader.endpoint === 'undefined' || reader.endpoint === '') {
//                 readerArrayErrors.reader.endpoint = 'reader.endpoint must not be empty'
//             }
//             if (!endpointPatt.test(reader.endpoint)) {
//                 readerArrayErrors.reader.endpoint = 'Endpoint format range must be from 0.0.0.0 to 255.255.255.255'
//             }
//         })
//     }
//     if (readerArrayErrors.length) {
//         errors.members = membersArrayErrors
//       }
//     // const { clientId, endpoint } = fields
//     // if (typeof clientId === 'undefined' || clientId === '') {
//     //     errors.clientId = 'displayName must not be empty'
//     // }
//     return errors
// }



// WEBPACK FOOTER //
// ./src/smart-components/reader-form/validate.js